/**
 * Browse bulk-edit helper functions (Spec 009-bulk-edit-completed, #295).
 *
 * Extracted as pure functions (ADR-048 Stufe 1, node-testable, no DOM).
 * Reuses mergeBulkTags from Spec 001 for tag-flush/dedupe parity (E7).
 */

import { mergeBulkTags } from './bulkTags';

/** Payload for the metadata-batch endpoint (Browse bulk-edit). */
export interface BrowseBulkPayload {
  userTags?: string[];
  householdId?: string;
  assignedTo?: string[];
}

/**
 * Input params for assembleBrowseBulkPayload.
 * Mirrors the two-way bound props on BulkReviewPanel.
 */
export interface BrowseBulkAcceptParams {
  bulkTags: string[];
  newTag: string;
  bulkHouseholdId: string;
  bulkAssignMemberIds: string[];
}

/**
 * Assembles the metadata-batch payload from the BulkReviewPanel chips (Spec 103 E6):
 * only set chips travel.
 *
 * Tags (Spec 001 E1–E3): mergeBulkTags flushes + dedupes the pending newTag.
 *
 * Household: only a non-empty id. The server cannot clear a household — an unknown id, also
 * "", raises HouseholdNotFoundException.
 *
 * Persons (replace semantics): only when at least one is chosen.
 *
 * Notes are never part of a bulk payload (Spec 103 E1).
 */
export function assembleBrowseBulkPayload(params: BrowseBulkAcceptParams): BrowseBulkPayload {
  const payload: BrowseBulkPayload = {};

  // Tag flush + dedupe (reuse Spec 001 mergeBulkTags, E7)
  const finalTags = mergeBulkTags(params.bulkTags, params.newTag);
  if (finalTags.length > 0) {
    payload.userTags = finalTags;
  }

  if (params.bulkHouseholdId) {
    payload.householdId = params.bulkHouseholdId;
  }

  // Persons: replace semantics (E6)
  if (params.bulkAssignMemberIds.length > 0) {
    payload.assignedTo = [...params.bulkAssignMemberIds];
  }

  return payload;
}
